module.exports = __webpack_public_path__ + "static/media/3.2051e0e8.jpg";